// extracted by mini-css-extract-plugin
export default {"card":"Card_card__sXMfr","animate":"Card_animate__3kDoG","img":"Card_img__xGqVF","content":"Card_content__trcu3","pos":"Card_pos__C2kcX","circle":"Card_circle__RYDyb"};